import { Box, styled, Typography, Link } from '@mui/material'
import { OrderProps } from '../../types/tracking'
import { translate } from '../../utils/resources'
import DEFAULT from '../../config/default'

const COMENTARIOS_HIDDEN_COUNTRIES: Array<string> = ['AR', 'EC']
const RECEPTOR_HIDDEN_COUNTRIES: Array<string> = ['AR', 'EC']

const showComentarios = !COMENTARIOS_HIDDEN_COUNTRIES.includes(DEFAULT.api.countryCode ?? '')
const showReceptor = !RECEPTOR_HIDDEN_COUNTRIES.includes(DEFAULT.api.countryCode ?? '')

const getDeliveryAddress = (order: OrderProps): string => {
    const parts = [
        order.direccionConsultora || order.consultora.direccion || '-',
        order.partido,
        order.localidad,
        order.provincia
    ]
    return parts.filter(Boolean).join(', ')
}

interface DataProps {
    order: OrderProps
}

const Data = ({ order }: DataProps) => {
    return (
        <>
            <Box>
                <Header>
                    Dirección de entrega
                </Header>
                <Body>
                    <Item>{ getDeliveryAddress(order) }</Item>
                </Body>
            </Box>
            <Box>
                <Header>
                    Transportista
                </Header>
                <Body>
                    <Item>{ order.nombreTransportista || '-' }</Item>
                </Body>
            </Box>
            
            { showComentarios && (
                <Box>
                    <Header>
                        Comentarios
                    </Header>
                    <Body>
                        <Item>{ order.comentarioTransportista || '-' }</Item>
                    </Body>
                </Box>
            )}
            { showReceptor && (
                <Box>
                    <Header>
                        Receptor
                    </Header>
                    <Body>
                        <Item>Nombre: { order.nombreRecibio || '-' }</Item>
                        <Item>DNI: { order.dniRecibio || '-' }</Item>
                    </Body>
                </Box>
            )}

            {(order.pathEntregaFallida || order.pathRemito) && (
                <Box>
                    <Header>
                        Archivos adjuntos
                    </Header>
                    <Body>
                        { order.pathEntregaFallida && (
                            <Item>
                                <Link href={order.pathEntregaFallida} target="_blank">
                                    {translate('order.data.pathEntregaFallida')}
                                </Link>
                            </Item>
                        )}
                        { order.pathRemito && (
                            <Item>
                                <Link href={order.pathRemito} target="_blank">
                                    {translate('order.data.pathRemito')}
                                </Link>
                            </Item>
                        )}
                    </Body>
                </Box>
            )}
            
        </>
    )
}

const Header = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    minHeight: theme.spacing(5.5),
    paddingTop: theme.spacing(.5),
    paddingBottom: theme.spacing(.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    background: theme.palette.grey[200],
    borderRadius: theme.spacing(.5),
    ...theme.typography.subtitle2
}))

const Body = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2)
}))

const Item = styled(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    wordWrap: 'break-word'
}))

export default Data
